import { __decorate, __param } from 'tslib';
import { Optional, Inject, forwardRef, ElementRef, Self, Input, HostBinding, HostListener, Component, ChangeDetectionStrategy, ContentChildren, ViewEncapsulation, Directive, NgModule } from '@angular/core';
import { isNativeFocused, setNativeFocused, tuiDefaultProp, EMPTY_QUERY, itemsQueryListObservable, moveFocus, isNativeFocusedIn, setNativeMouseFocused, isPresent, tuiAssertIsHTMLElement, tuiPure, typedFromEvent, preventDefault, getClosestKeyboardFocusable } from '@taiga-ui/cdk';
import { TUI_OPTION_CONTENT, TUI_DATA_LIST_HOST, TUI_NOTHING_FOUND_MESSAGE, TUI_DATA_LIST_ACCESSOR } from '@taiga-ui/core/tokens';
import { Observable, merge, EMPTY } from 'rxjs';
import { map, switchMap, take, filter, tap, shareReplay, mapTo, debounceTime } from 'rxjs/operators';
import { TuiDropdownDirective } from '@taiga-ui/core/directives/dropdown';
import { shouldCall } from '@tinkoff/ng-event-plugins';
import { CommonModule } from '@angular/common';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc3 from '@taiga-ui/core/components/svg';
import * as ɵngcc4 from '@taiga-ui/core/directives/dropdown';
import * as ɵngcc5 from 'rxjs';

const _c0 = ["tuiOption", ""];
const _c1 = function (a0) { return { $implicit: a0 }; };
function TuiOptionComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("content", ctx_r0.content)("context", ɵngcc0.ɵɵpureFunction1(2, _c1, _r1));
} }
function TuiOptionComponent_ng_template_1_tui_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 4);
} }
function TuiOptionComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
    ɵngcc0.ɵɵtemplate(1, TuiOptionComponent_ng_template_1_tui_svg_1_Template, 1, 0, "tui-svg", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.dropdown);
} }
const _c2 = ["*"];
function TuiDataListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r0.emptyContent || ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.defaultEmptyContent$));
} }
function shouldFocus({ currentTarget, }) {
    return !isNativeFocused(currentTarget);
}
// TODO: Consider all use cases for aria roles
let TuiOptionComponent = class TuiOptionComponent {
    // TODO: Fix dataList type when updated to Ivy and compilation drops metadata
    constructor(content, dataList, elementRef, host, dropdown) {
        this.content = content;
        this.dataList = dataList;
        this.elementRef = elementRef;
        this.host = host;
        this.dropdown = dropdown;
        this.size = 'm';
        this.role = 'option';
        this.disabled = false;
    }
    get active() {
        return !!this.dropdown && !!this.dropdown.dropdownBoxRef;
    }
    onClick() {
        if (this.host && this.value !== undefined) {
            this.host.handleOption(this.value);
        }
    }
    // @bad TODO: Consider aria-activedescendant for proper accessibility implementation
    onMouseMove({ currentTarget }) {
        setNativeFocused(currentTarget, true, true);
    }
    // Preventing focus loss upon focused option removal
    ngOnDestroy() {
        this.dataList.handleFocusLossIfNecessary(this.elementRef.nativeElement);
    }
};
TuiOptionComponent.ɵfac = function TuiOptionComponent_Factory(t) { return new (t || TuiOptionComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_OPTION_CONTENT, 8), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => TuiDataListComponent)), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_DATA_LIST_HOST, 8), ɵngcc0.ɵɵdirectiveInject(TuiDropdownDirective, 10)); };
TuiOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiOptionComponent, selectors: [["button", "tuiOption", ""], ["a", "tuiOption", ""]], hostAttrs: ["tabIndex", "-1", "type", "button"], hostVars: 5, hostBindings: function TuiOptionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TuiOptionComponent_click_HostBindingHandler() { return ctx.onClick(); })("mousemove.init", function TuiOptionComponent_mousemove_init_HostBindingHandler($event) { return ctx.onMouseMove($event); })("mousemove.silent", function TuiOptionComponent_mousemove_silent_HostBindingHandler($event) { return ctx.onMouseMove($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null)("data-size", ctx.size)("role", ctx.role);
        ɵngcc0.ɵɵclassProp("_with-dropdown", ctx.active);
    } }, inputs: { size: "size", role: "role", disabled: "disabled", value: "value" }, attrs: _c0, ngContentSelectors: _c2, decls: 3, vars: 2, consts: [["polymorpheus-outlet", "", "class", "content", 3, "content", "context", 4, "ngIf", "ngIfElse"], ["base", ""], ["polymorpheus-outlet", "", 1, "content", 3, "content", "context"], ["src", "tuiIconChevronRight", "class", "arrow", 4, "ngIf"], ["src", "tuiIconChevronRight", 1, "arrow"]], template: function TuiOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiOptionComponent_span_0_Template, 1, 4, "span", 0);
        ɵngcc0.ɵɵtemplate(1, TuiOptionComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.content)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.PolymorpheusOutletComponent, ɵngcc3.TuiSvgComponent], styles: ["[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 1rem;border:0;background:padding-box;font-size:inherit;line-height:inherit;transition-property:background;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:flex;font:var(--tui-font-text-m);width:100%;align-items:center;justify-content:space-between;text-align:left;box-sizing:border-box;color:var(--tui-text-01);outline:0;text-decoration:none;cursor:pointer;border-top:8px solid transparent;border-bottom:8px solid transparent;margin:-.5rem 0}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);cursor:default}._with-dropdown[_nghost-%COMP%], [_nghost-%COMP%]:focus{background-color:var(--tui-base-02)}[data-size=xs][_nghost-%COMP%]{font:var(--tui-font-text-s);min-height:3rem}[data-size='s'][_nghost-%COMP%]{min-height:3rem}[data-size='m'][_nghost-%COMP%]{min-height:3.75rem}[data-size='l'][_nghost-%COMP%]{min-height:4.5rem}.content[_ngcontent-%COMP%]{display:flex;flex:1;max-width:100%}.arrow[_ngcontent-%COMP%]{margin:0 -.5rem 0 .75rem}"], changeDetection: 0 });
TuiOptionComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [TUI_OPTION_CONTENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [forwardRef(() => TuiDataListComponent),] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [TUI_DATA_LIST_HOST,] }] },
    { type: TuiDropdownDirective, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [TuiDropdownDirective,] }] }
];
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiOptionComponent.prototype, "size", void 0);
__decorate([
    Input(),
    HostBinding('attr.role'),
    tuiDefaultProp()
], TuiOptionComponent.prototype, "role", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiOptionComponent.prototype, "disabled", void 0);
__decorate([
    Input()
], TuiOptionComponent.prototype, "value", void 0);
__decorate([
    HostBinding('class._with-dropdown')
], TuiOptionComponent.prototype, "active", null);
__decorate([
    HostListener('click')
], TuiOptionComponent.prototype, "onClick", null);
__decorate([
    shouldCall(shouldFocus),
    HostListener('mousemove.init', ['$event']),
    HostListener('mousemove.silent', ['$event'])
], TuiOptionComponent.prototype, "onMouseMove", null);
TuiOptionComponent = __decorate([ __param(0, Optional()),
    __param(0, Inject(TUI_OPTION_CONTENT)),
    __param(1, Inject(forwardRef(() => TuiDataListComponent))),
    __param(2, Inject(ElementRef)),
    __param(3, Optional()),
    __param(3, Inject(TUI_DATA_LIST_HOST)),
    __param(4, Optional()),
    __param(4, Self()),
    __param(4, Inject(TuiDropdownDirective))
], TuiOptionComponent);

var TuiDataListComponent_1;
// TODO: Consider aria-activedescendant for proper accessibility implementation
// @dynamic
let TuiDataListComponent = TuiDataListComponent_1 = class TuiDataListComponent {
    constructor(elementRef, defaultEmptyContent$) {
        this.elementRef = elementRef;
        this.defaultEmptyContent$ = defaultEmptyContent$;
        this.options = EMPTY_QUERY;
        this.role = 'listbox';
        this.emptyContent = '';
    }
    get empty$() {
        return itemsQueryListObservable(this.options).pipe(map(({ length }) => !length));
    }
    onFocusIn(relatedTarget, currentTarget) {
        if (!currentTarget.contains(relatedTarget) && !this.origin) {
            this.origin = relatedTarget;
        }
    }
    noop() { }
    onKeyDownArrow(current, step) {
        const { elements } = this;
        moveFocus(elements.indexOf(current), elements, step);
    }
    // TODO: Consider aria-activedescendant for proper accessibility implementation
    handleFocusLossIfNecessary(element) {
        if (this.origin && isNativeFocusedIn(element)) {
            setNativeMouseFocused(this.origin, true, true);
        }
    }
    getOptions(includeDisabled = false) {
        return this.options
            .toArray()
            .filter(({ disabled }) => includeDisabled || !disabled)
            .map(({ value }) => value)
            .filter(isPresent);
    }
    onFocus({ target }, top) {
        tuiAssertIsHTMLElement(target);
        const { elements } = this;
        moveFocus(top ? -1 : elements.length, elements, top ? 1 : -1);
        this.handleFocusLossIfNecessary(target);
    }
    get elements() {
        return Array.from(this.elementRef.nativeElement.querySelectorAll('[tuiOption]'));
    }
};
TuiDataListComponent.ɵfac = function TuiDataListComponent_Factory(t) { return new (t || TuiDataListComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TUI_NOTHING_FOUND_MESSAGE)); };
TuiDataListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDataListComponent, selectors: [["tui-data-list"]], contentQueries: function TuiDataListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, hostVars: 1, hostBindings: function TuiDataListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function TuiDataListComponent_focusin_HostBindingHandler($event) { return ctx.onFocusIn($event.relatedTarget, $event.currentTarget); })("mousedown.prevent", function TuiDataListComponent_mousedown_prevent_HostBindingHandler() { return ctx.noop(); })("keydown.arrowDown.prevent", function TuiDataListComponent_keydown_arrowDown_prevent_HostBindingHandler($event) { return ctx.onKeyDownArrow($event.target, 1); })("keydown.arrowUp.prevent", function TuiDataListComponent_keydown_arrowUp_prevent_HostBindingHandler($event) { return ctx.onKeyDownArrow($event.target, -1); })("wheel.silent.passive", function TuiDataListComponent_wheel_silent_passive_HostBindingHandler($event) { return ctx.handleFocusLossIfNecessary($event.currentTarget); })("mouseleave", function TuiDataListComponent_mouseleave_HostBindingHandler($event) { return ctx.handleFocusLossIfNecessary($event.target); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { role: "role", emptyContent: "emptyContent" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_DATA_LIST_ACCESSOR,
                useExisting: forwardRef(() => TuiDataListComponent_1)
            },
        ])], ngContentSelectors: _c2, decls: 5, vars: 3, consts: [["tabindex", "0", 1, "trap", 3, "focusin"], ["polymorpheus-outlet", "", "class", "empty", 3, "content", 4, "ngIf"], ["polymorpheus-outlet", "", 1, "empty", 3, "content"]], template: function TuiDataListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("focusin", function TuiDataListComponent_Template_div_focusin_0_listener($event) { return ctx.onFocus($event, true); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, TuiDataListComponent_div_2_Template, 2, 3, "div", 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementStart(4, "div", 0);
        ɵngcc0.ɵɵlistener("focusin", function TuiDataListComponent_Template_div_focusin_4_listener($event) { return ctx.onFocus($event, false); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.empty$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.PolymorpheusOutletComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["tui-data-list{display:flex;font:var(--tui-font-text-m);flex-direction:column;padding:.5rem 0;color:var(--tui-text-03)}tui-data-list:focus-within .trap{display:none}tui-data-list:focus-within [tuiOption]._with-dropdown:not(:focus){background-color:transparent}tui-data-list>.empty{margin:.75rem 1rem}tui-opt-group{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:relative;display:flex;font:var(--tui-font-text-xs);flex-direction:column;line-height:2rem;padding:.5rem 0;margin:-.5rem 0}tui-opt-group:empty:after,tui-opt-group:empty:before{display:none}tui-opt-group:before{content:attr(data-label);padding:0 1rem;color:var(--tui-text-02)}tui-opt-group:not(:empty)~tui-opt-group:before{padding-top:1rem}tui-opt-group:not(:empty)~tui-opt-group:after{content:'';position:absolute;left:0;right:0;top:.4375rem;height:1px;background:var(--tui-base-03)}"], encapsulation: 2, changeDetection: 0 });
TuiDataListComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_NOTHING_FOUND_MESSAGE,] }] }
];
__decorate([
    ContentChildren(forwardRef(() => TuiOptionComponent), { descendants: true })
], TuiDataListComponent.prototype, "options", void 0);
__decorate([
    Input(),
    HostBinding('attr.role'),
    tuiDefaultProp()
], TuiDataListComponent.prototype, "role", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiDataListComponent.prototype, "emptyContent", void 0);
__decorate([
    tuiPure
], TuiDataListComponent.prototype, "empty$", null);
__decorate([
    HostListener('focusin', ['$event.relatedTarget', '$event.currentTarget'])
], TuiDataListComponent.prototype, "onFocusIn", null);
__decorate([
    HostListener('mousedown.prevent')
], TuiDataListComponent.prototype, "noop", null);
__decorate([
    HostListener('keydown.arrowDown.prevent', ['$event.target', '1']),
    HostListener('keydown.arrowUp.prevent', ['$event.target', '-1'])
], TuiDataListComponent.prototype, "onKeyDownArrow", null);
__decorate([
    HostListener('wheel.silent.passive', ['$event.currentTarget']),
    HostListener('mouseleave', ['$event.target'])
], TuiDataListComponent.prototype, "handleFocusLossIfNecessary", null);
TuiDataListComponent = TuiDataListComponent_1 = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TUI_NOTHING_FOUND_MESSAGE))
], TuiDataListComponent);

let TuiDataListDirective = class TuiDataListDirective {
};
TuiDataListDirective.ɵfac = function TuiDataListDirective_Factory(t) { return new (t || TuiDataListDirective)(); };
TuiDataListDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDataListDirective, selectors: [["ng-template", "tuiDataList", ""]] });

// TODO: Move into separate module in 3.0
let TuiDataListDropdownManagerDirective = class TuiDataListDropdownManagerDirective {
    constructor() {
        this.dropdowns = EMPTY_QUERY;
        this.elements = EMPTY_QUERY;
    }
    ngAfterViewInit() {
        this.right$.subscribe(index => {
            this.tryToFocus(index);
        });
        merge(this.immediate$, this.debounce$)
            .pipe(switchMap(active => {
            this.dropdowns.forEach((dropdown, index) => {
                dropdown.open = index === active;
            });
            const element = this.elements.toArray()[active];
            const dropdown = this.dropdowns.toArray()[active];
            if (!element || !dropdown || !dropdown.dropdownBoxRef) {
                return EMPTY;
            }
            const { nativeElement } = dropdown.dropdownBoxRef.location;
            const mouseEnter$ = typedFromEvent(nativeElement, 'mouseenter').pipe(take(1));
            const esc$ = merge(typedFromEvent(element.nativeElement, 'keydown'), typedFromEvent(nativeElement, 'keydown')).pipe(filter(({ keyCode }) => keyCode === 27));
            return merge(mouseEnter$, esc$).pipe(tap(event => {
                if (dropdown.dropdownBoxRef) {
                    event.stopPropagation();
                }
                setNativeFocused(element.nativeElement);
                // TODO: iframe warning
                dropdown.open = event instanceof MouseEvent;
            }));
        }))
            .subscribe();
    }
    get elements$() {
        return itemsQueryListObservable(this.elements).pipe(map(array => array.map(({ nativeElement }) => nativeElement)), shareReplay({ bufferSize: 1, refCount: true }));
    }
    get right$() {
        return this.elements$.pipe(switchMap(elements => merge(...elements.map((element, index) => typedFromEvent(element, 'keydown').pipe(filter(({ keyCode }) => keyCode === 39), preventDefault(), mapTo(index))))));
    }
    get immediate$() {
        return this.elements$.pipe(switchMap(elements => merge(...elements.map((element, index) => typedFromEvent(element, 'click').pipe(mapTo(index))))));
    }
    get debounce$() {
        return this.elements$.pipe(switchMap(elements => merge(...elements.map((element, index) => merge(typedFromEvent(element, 'focus'), typedFromEvent(element, 'blur')).pipe(filter(({ relatedTarget }) => this.notInDropdown(relatedTarget, index)), map(({ type }) => (type === 'focus' ? index : NaN)))))), debounceTime(300));
    }
    notInDropdown(element, index) {
        const dropdown = this.dropdowns.toArray()[index];
        return (!dropdown ||
            !dropdown.dropdownBoxRef ||
            !dropdown.dropdownBoxRef.location.nativeElement.contains(element));
    }
    tryToFocus(index) {
        const dropdown = this.dropdowns.toArray()[index];
        const content = dropdown &&
            dropdown.dropdownBoxRef &&
            dropdown.dropdownBoxRef.instance.contentElementRef;
        if (!content) {
            return;
        }
        const item = getClosestKeyboardFocusable(content.nativeElement, false, content.nativeElement);
        if (item) {
            setNativeFocused(item);
        }
    }
};
TuiDataListDropdownManagerDirective.ɵfac = function TuiDataListDropdownManagerDirective_Factory(t) { return new (t || TuiDataListDropdownManagerDirective)(); };
TuiDataListDropdownManagerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDataListDropdownManagerDirective, selectors: [["tui-data-list", "tuiDataListDropdownManager", ""]], contentQueries: function TuiDataListDropdownManagerDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiDropdownDirective, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiDropdownDirective, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdowns = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.elements = _t);
    } } });
__decorate([
    ContentChildren(TuiDropdownDirective, { descendants: true })
], TuiDataListDropdownManagerDirective.prototype, "dropdowns", void 0);
__decorate([
    ContentChildren(TuiDropdownDirective, { read: ElementRef, descendants: true })
], TuiDataListDropdownManagerDirective.prototype, "elements", void 0);
__decorate([
    tuiPure
], TuiDataListDropdownManagerDirective.prototype, "elements$", null);
__decorate([
    tuiPure
], TuiDataListDropdownManagerDirective.prototype, "right$", null);
__decorate([
    tuiPure
], TuiDataListDropdownManagerDirective.prototype, "immediate$", null);
__decorate([
    tuiPure
], TuiDataListDropdownManagerDirective.prototype, "debounce$", null);

let TuiOptGroupDirective = class TuiOptGroupDirective {
    constructor() {
        this.label = '';
    }
};
TuiOptGroupDirective.ɵfac = function TuiOptGroupDirective_Factory(t) { return new (t || TuiOptGroupDirective)(); };
TuiOptGroupDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiOptGroupDirective, selectors: [["tui-opt-group"]], hostAttrs: ["role", "group"], hostVars: 1, hostBindings: function TuiOptGroupDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-label", ctx.label);
    } }, inputs: { label: "label" } });
__decorate([
    Input(),
    HostBinding('attr.data-label'),
    tuiDefaultProp()
], TuiOptGroupDirective.prototype, "label", void 0);

let TuiDataListModule = class TuiDataListModule {
};
TuiDataListModule.ɵfac = function TuiDataListModule_Factory(t) { return new (t || TuiDataListModule)(); };
TuiDataListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDataListModule });
TuiDataListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TuiSvgModule, PolymorpheusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiOptionComponent, [{
        type: Component,
        args: [{
                selector: `button[tuiOption], a[tuiOption]`,
                template: "<span\n    *ngIf=\"content; else base\"\n    polymorpheus-outlet\n    class=\"content\"\n    [content]=\"content\"\n    [context]=\"{$implicit: base}\"\n></span>\n<ng-template #base>\n    <ng-content></ng-content>\n    <tui-svg\n        *ngIf=\"dropdown\"\n        src=\"tuiIconChevronRight\"\n        class=\"arrow\"\n    ></tui-svg>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    tabIndex: '-1',
                    type: 'button',
                    '[attr.disabled]': 'disabled || null'
                },
                styles: [":host{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0 1rem;border:0;background:padding-box;font-size:inherit;line-height:inherit;transition-property:background;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;display:flex;font:var(--tui-font-text-m);width:100%;align-items:center;justify-content:space-between;text-align:left;box-sizing:border-box;color:var(--tui-text-01);outline:0;text-decoration:none;cursor:pointer;border-top:8px solid transparent;border-bottom:8px solid transparent;margin:-.5rem 0}:host:disabled{opacity:var(--tui-disabled-opacity);cursor:default}:host._with-dropdown,:host:focus{background-color:var(--tui-base-02)}:host[data-size=xs]{font:var(--tui-font-text-s);min-height:3rem}:host[data-size='s']{min-height:3rem}:host[data-size='m']{min-height:3.75rem}:host[data-size='l']{min-height:4.5rem}.content{display:flex;flex:1;max-width:100%}.arrow{margin:0 -.5rem 0 .75rem}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TUI_OPTION_CONTENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [forwardRef(() => TuiDataListComponent)]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TUI_DATA_LIST_HOST]
            }] }, { type: ɵngcc4.TuiDropdownDirective, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [TuiDropdownDirective]
            }] }]; }, { size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], role: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.role']
        }], disabled: [{
            type: Input
        }], active: [{
            type: HostBinding,
            args: ['class._with-dropdown']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], 
    // @bad TODO: Consider aria-activedescendant for proper accessibility implementation
    onMouseMove: [{
            type: HostListener,
            args: ['mousemove.init', ['$event']]
        }, {
            type: HostListener,
            args: ['mousemove.silent', ['$event']]
        }], value: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListComponent, [{
        type: Component,
        args: [{
                selector: 'tui-data-list',
                template: "<div\n    tabindex=\"0\"\n    class=\"trap\"\n    (focusin)=\"onFocus($event, true)\"\n></div>\n<ng-content></ng-content>\n<div\n    *ngIf=\"empty$ | async\"\n    polymorpheus-outlet\n    class=\"empty\"\n    [content]=\"emptyContent || (defaultEmptyContent$ | async)\"\n></div>\n<div\n    tabindex=\"0\"\n    class=\"trap\"\n    (focusin)=\"onFocus($event, false)\"\n></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: TUI_DATA_LIST_ACCESSOR,
                        useExisting: forwardRef(() => TuiDataListComponent_1)
                    },
                ],
                styles: ["tui-data-list{display:flex;font:var(--tui-font-text-m);flex-direction:column;padding:.5rem 0;color:var(--tui-text-03)}tui-data-list:focus-within .trap{display:none}tui-data-list:focus-within [tuiOption]._with-dropdown:not(:focus){background-color:transparent}tui-data-list>.empty{margin:.75rem 1rem}tui-opt-group{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:relative;display:flex;font:var(--tui-font-text-xs);flex-direction:column;line-height:2rem;padding:.5rem 0;margin:-.5rem 0}tui-opt-group:empty:after,tui-opt-group:empty:before{display:none}tui-opt-group:before{content:attr(data-label);padding:0 1rem;color:var(--tui-text-02)}tui-opt-group:not(:empty)~tui-opt-group:before{padding-top:1rem}tui-opt-group:not(:empty)~tui-opt-group:after{content:'';position:absolute;left:0;right:0;top:.4375rem;height:1px;background:var(--tui-base-03)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc5.Observable, decorators: [{
                type: Inject,
                args: [TUI_NOTHING_FOUND_MESSAGE]
            }] }]; }, { options: [{
            type: ContentChildren,
            args: [forwardRef(() => TuiOptionComponent), { descendants: true }]
        }], role: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.role']
        }], emptyContent: [{
            type: Input
        }], onFocusIn: [{
            type: HostListener,
            args: ['focusin', ['$event.relatedTarget', '$event.currentTarget']]
        }], noop: [{
            type: HostListener,
            args: ['mousedown.prevent']
        }], onKeyDownArrow: [{
            type: HostListener,
            args: ['keydown.arrowDown.prevent', ['$event.target', '1']]
        }, {
            type: HostListener,
            args: ['keydown.arrowUp.prevent', ['$event.target', '-1']]
        }], 
    // TODO: Consider aria-activedescendant for proper accessibility implementation
    handleFocusLossIfNecessary: [{
            type: HostListener,
            args: ['wheel.silent.passive', ['$event.currentTarget']]
        }, {
            type: HostListener,
            args: ['mouseleave', ['$event.target']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[tuiDataList]'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListDropdownManagerDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-data-list[tuiDataListDropdownManager]'
            }]
    }], function () { return []; }, { dropdowns: [{
            type: ContentChildren,
            args: [TuiDropdownDirective, { descendants: true }]
        }], elements: [{
            type: ContentChildren,
            args: [TuiDropdownDirective, { read: ElementRef, descendants: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiOptGroupDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-opt-group',
                host: {
                    role: 'group'
                }
            }]
    }], function () { return []; }, { label: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-label']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDataListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule, PolymorpheusModule],
                declarations: [
                    TuiDataListComponent,
                    TuiOptionComponent,
                    TuiOptGroupDirective,
                    TuiDataListDirective,
                    TuiDataListDropdownManagerDirective,
                ],
                exports: [
                    TuiDataListComponent,
                    TuiOptionComponent,
                    TuiOptGroupDirective,
                    TuiDataListDirective,
                    TuiDataListDropdownManagerDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDataListModule, { declarations: function () { return [TuiDataListComponent, TuiOptionComponent, TuiOptGroupDirective, TuiDataListDirective, TuiDataListDropdownManagerDirective]; }, imports: function () { return [CommonModule, TuiSvgModule, PolymorpheusModule]; }, exports: function () { return [TuiDataListComponent, TuiOptionComponent, TuiOptGroupDirective, TuiDataListDirective, TuiDataListDropdownManagerDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDataListComponent, TuiDataListDirective, TuiDataListDropdownManagerDirective, TuiDataListModule, TuiOptGroupDirective, TuiOptionComponent, shouldFocus };

